import React, { useEffect, useState } from "react";
import * as service from "../../store/service";
import parse, { domToReact } from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { useHistory } from "react-router-dom";

const SSOTermsAndCondition = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setSubmitted] = useState(false);
    const [agreed, setAgreed] = useState(false);
    const [showError, setShowError] = useState(true);
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const termsAndCondition = useSelector((state: ApplicationState) => {
        return state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.termsContent
            ? state.configurationState.configuration.partnerConfig.termsContent
            : "";
    });
    let authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                partnerId: state.loggedInUser?.userInfo?.partnerID,
                status: state.creditAuthData.authData["status-code"],
            };
        }
        return { isIDFUser: "", partnerId: 36, status: "" };
    });

    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;

            if (attribs.hasOwnProperty("class")) {
                if (attribs.class.indexOf("pdfPrint_icons") !== -1) {
                    return (
                        <a href="javascript:window.print()">
                            <i className="las la-print" style={{ fontSize: "32px", float: "right" }}></i>
                        </a>
                    );
                }
            }

            if (attribs.hasOwnProperty("src")) {
                if (attribs.src.indexOf("/Partner/MTB/checkmark.png") !== -1) {
                    return <i className="las la-check"></i>;
                }
            }

            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("window.print()") !== -1) {
                    return <a href="javascript:window.print();">{domToReact(children, options)}</a>;
                }

                if (attribs.href.indexOf("CommonDefinitions") !== -1 && authData.isIDFUser === false)
                    return (
                        <a href="/common-definition" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("privacy-policy") !== -1 ||
                    attribs.href.indexOf("canadian-privacy-policy") !== -1 ||
                    attribs.href.indexOf("PrivacyPolicy") !== -1
                )
                    return (
                        <a href="/privacy" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (
                    attribs.href.indexOf("EU-USPrivacyShield") !== -1 ||
                    attribs.href.indexOf("EUUSPrivacyShield") !== -1 ||
                    attribs.href.indexOf("privacy-shield-policy") !== -1
                )
                    return (
                        <a href="/privacy-shield" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("EUGDPRNotice") !== -1 || attribs.href.indexOf("eu-gdpr-fair-processing-notice") !== -1)
                    return (
                        <a href="/gdpr" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf("ccpa-addendum") !== -1 || attribs.href.indexOf("CCPAAddendum") !== -1)
                    return (
                        <a href="/ccpa" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    );

                if (attribs.href.indexOf(window.location.hostname) === -1)
                    return (
                        <a href={attribs.href} target="_blank" rel="noreferrer">
                            {domToReact(children, options)}
                        </a>
                    );
            }
        },
    };

    const acceptTermsAndConditions = () => {
        setSubmitted(true);
        if (agreed) {
            setLoading(true);
            service
                .acceptSsoTermsConditions()
                .then((data) => {
                    setLoading(false);
                    if (data.isSuccess) {
                        history.push("/Login");
                    } else {
                        history.push({
                            pathname: "/register/error",
                            state: {
                                fromRegistration: true,
                            },
                        });
                    }
                })
                .catch(() => {
                    setLoading(false);
                    history.push({
                        pathname: "/register/error",
                        state: {
                            fromRegistration: true,
                        },
                    });
                });
        }
    };

    const handleUpdateChecked = () => {
        if (agreed) {
            setShowError(true);
            setAgreed(false);
        } else {
            setShowError(false);
            setAgreed(true);
        }
    };

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className="dialog-header" style={{ padding: "1.5rem" }}>
                <h1>We've updated our Terms and Conditions</h1>
                <div className="margin-vertical-l"></div>
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <div className="form-row">
                            <div className="form-input">
                                <label className="form-checkbox-label" >
                                    <input type="checkbox"  name="accept-terms-and-condition" checked={agreed} onChange={() => handleUpdateChecked()} />
                                    <span className="form-checkbox-label-text">I accept the Terms and Conditions.</span>
                                </label>
                            </div>
                            {isSubmitted && showError && <span className="form-error">To continue you must accept the Terms and Conditions.</span>}
                        </div>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={acceptTermsAndConditions}>
                            <span className="btn-text">Continue</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className={loading ? " loading dialog-body" : "dialog-body large-dialog-scroll"} style={{ padding: "1.5rem", maxHeight: "unset" }}>
                {parse(termsAndCondition, options)}
            </div>

            <div className="dialog-footer" style={{ padding: "1.5rem" }}>
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <div className="form-row">
                            <div className="form-input">
                                <label className="form-checkbox-label" >
                                    <input type="checkbox"  name="accept-terms-and-condition" checked={agreed} onChange={() => handleUpdateChecked()} />
                                    <span className="form-checkbox-label-text">I accept the Terms and Conditions.</span>
                                </label>
                            </div>
                            {isSubmitted && showError && <span className="form-error">To continue you must accept the Terms and Conditions.</span>}
                        </div>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={acceptTermsAndConditions}>
                            <span className="btn-text">Continue</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SSOTermsAndCondition;
